import { getSettledTransactions, getAccountBalance } from "../../API/TransactionManager";
import { Transaction } from "../../Types/Transaction";
import { useEffect, useState } from "react";

import transactionsStyle from "../../General CSS/Table.module.css";

import Header from "../../Header";
import {AccountBalance} from "../../Types/Balance";
import {useNavigate} from "react-router-dom";
import claimIcon from "../../Images/reinburse.png";
import bankAccount from "../../Images/bank_account.png";

export default function Overview() {
    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const now = new Date();
        const oneMonthAgo = new Date(now);
        oneMonthAgo.setFullYear(oneMonthAgo.getFullYear() - 1);
        getSettledTransactions(oneMonthAgo, now)
            .then(setTransactions)
            .catch(err => setError(err.message || "Unknown Error"))
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <Header page={"Transactions"}
                    links={[
                        {src: bankAccount, href: "/account/my-account", alt: "Manage My Account"},
                        {src: claimIcon, href: "/account/view-claims", alt: "View Claims"},
                    ]}
                    returnLink={"/"}
            />
            <AccountDetails />
            {transactions ? (
                <LoadTransactions transactions={transactions} />
            ) : (
                <p>Loading Transactions...</p>
            )}
        </>
    )
}

function AccountDetails() {
    const [balance, setBalance] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        getAccountBalance()
            .then((data: AccountBalance) => {
                setBalance(data.effectiveBalance.minorUnits / 100);
            })
            .catch(err => setError(err.message || "Unknown Error"))
            .finally(() => setLoading(false))
    }, []);

    return (
        <div className={transactionsStyle.accountDetails}>
            <h2 className={transactionsStyle.balance}>Balance: £{balance}</h2>
            <h3>88470152 | 60-83-71</h3>
        </div>
    )
}

function LoadTransactions({transactions}: LoadTransactionsProps) {
    const navigate = useNavigate();

    function viewNote(transactionUid: string, categoryUid: string): void {
        navigate("/account/note/" + categoryUid + "/" + transactionUid);
    }

    const reversedTransactions = [...transactions].reverse();
    return (
        <div className={transactionsStyle.table}>
            <table>
                <tbody>
                <tr>
                    <th>Name</th>
                    <th>Currency</th>
                    <th>Amount</th>
                    <th>Time</th>
                    <th>Notes</th>
                </tr>
                {reversedTransactions.map((transaction: Transaction) => (
                    <tr key={transaction.id}>
                        <td><strong>{transaction.name}</strong></td>
                        <td>{transaction.currency}</td>
                        <td style={{
                            color: transaction.direction === "IN" ? "#00b83c" : "#e10000",
                        }}>{transaction.amount}</td>
                        <td>{new Date(transaction.time).toLocaleDateString("en-GB", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                        })}</td>
                        <td style={{ fontWeight: transaction.note === "" ? "bold" : 500 }}
                            className={transactionsStyle.link}
                            onClick={(): void => viewNote(transaction.id, transaction.categoryUid)}
                        >{transaction.note === "" ? "Add Note" : transaction.note}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}

type LoadTransactionsProps = {
    transactions: Transaction[];
}